import React from 'react'
import { ShareWithoutVersion } from 'modules/versioning'
import InvitePeople from 'modules/shares/modals/ShareSettingsModal/InvitePeople'
import ShareMemberships from 'modules/shares/modals/ShareSettingsModal/ShareMemberships'

export const GuestsTitle = ({ guestsCount }: { guestsCount: number }) => (
  <>Guests ({guestsCount})</>
)

export const GuestsPanel = ({ share }: { share: ShareWithoutVersion }) => {
  return (
    <>
      <InvitePeople
        hideLabel
        data-testid="sharing-guests-invite"
        share={share}
      />
      <ShareMemberships share={share} />
    </>
  )
}
